import styled from 'styled-components';

export const VerifyAccountContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 15rem 0 20rem;

    section {
        max-width: 60rem;
    }
`;

export const EnterVerificationCode = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > img {
        width: 20rem;
        margin-bottom: 4rem;
    }

    .heading {
        text-align: center;
        max-width: 30rem;
        margin-bottom: 5rem;

        h1 {
            font-size: 2.5rem;
            margin-bottom: 2rem;
        }

        p {
            font-size: 1.6rem;
            line-height: 150%;
        }
    }

    form {
        display: flex;
        flex-direction: column;
        align-items: center;

        input {
            text-align: center;

            width: 20rem;
            height: 6rem;
            margin-bottom: 5rem;

            font-size: 1.8rem;
            font-weight: bold;

            color: #000;

            border: 2px solid rgba(0, 0, 0, .5);
            border-radius: 1rem;

            &:focus {
                border: 3px solid var(--color-primary);
            }
        }
    }
`;